<template>
	<Page>
		<template v-if="task && taskImage" #default>
			<ActivityIcon :icon="taskImage" class="task-image" />

			<h1>{{ task.title }}</h1>

			<div class="description">
				<BaseMarkdown :raw="task.description" />
			</div>
		</template>

		<template v-if="task" #footer>
			<TaskLink :url="task.url" @click="openLink(task)" />
			<BaseButton :loading="taskComplete.isLoading.value" @click="taskComplete.mutate(task)">
				Complete
			</BaseButton>
		</template>
	</Page>
</template>

<script setup lang="ts">
import BaseButton from '@/components/ui/BaseButton.vue';
import BaseMarkdown from '@/components/ui/BaseMarkdown.vue';
import Page from '@/components/ui/Page.vue';
import { useTelegram } from '@/composables/useTelegram';
import ActivityIcon from '@/features/tasks/components/ActivityIcon.vue';
import TaskLink from '@/features/tasks/components/TaskLink.vue';
import { useTask, type ITaskDto, useTaskComplete } from '@/features/tasks/hooks/useTask';
import { TASK_ICON_BY_TYPE } from '@/features/tasks/utils';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const { telegram } = useTelegram();

const taskId = computed(() => route.params.taskId as string);

const { data: task } = useTask(taskId);
const taskComplete = useTaskComplete({ redirectTo: '/earn' });

const taskImage = computed(() => (task.value ? TASK_ICON_BY_TYPE[task.value.type] : null));

const openLink = (task: ITaskDto) => {
	if (task.url.startsWith('https://t.me/')) telegram.WebApp.openTelegramLink(task.url);
	else telegram.WebApp.openLink(task.url);
};
</script>

<style scoped>
.task-image {
	box-sizing: border-box;

	width: 163px;
	height: 163px;

	background: linear-gradient(0deg, rgba(2, 122, 255, 0.05), rgba(2, 122, 255, 0.05)),
		linear-gradient(180deg, rgba(255, 255, 255, 0.01) 0%, rgba(255, 255, 255, 0.05) 100%);
	border: 1px solid rgba(255, 255, 255, 0.03);
	border-radius: 32px;

	margin: auto;
}

h1 {
	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 600;
	font-size: 20px;
	line-height: 24px;
	text-align: center;

	color: rgba(255, 255, 255, 0.8);
}

.description {
	font-family: 'Exo 2';
	font-style: normal;
	font-weight: 300;
	font-size: 13px;
	line-height: 16px;

	color: rgba(255, 255, 255, 0.7);

	word-wrap: break-word;
}
</style>
